// 帮助中心详情
<template>
  <div class="feedback">
    <van-nav-bar left-arrow :title="$t('menu.feedback')" @click-left="$router.go(-1)" left-arrow fixed placeholder />
    <section>
      <div class="card">
        <van-field
          v-model="message"
          rows="5"
          autosize
          type="textarea"
          placeholder=""
        />
      </div>
      <van-button class="submit" block round size="large" color="linear-gradient(30deg, #3EE191, #24DEDD)" type="info" @click="submit">
        {{ 'Submit' }}
      </van-button>
    </section>
  </div>
</template>

<script>
import { toFeedback } from '@/api'
export default {
  name: 'Feedback',
  data () {
    return {
      message: ''
    }
  },
  methods: {
    // 初始化列表
    submit () {
      toFeedback({
        content: this.message
      }).then(res => {
        this.$router.go(-1)
        this.$toast(res.msg)
      })
    }
  }
}
</script>

<style lang="less">
  .feedback {
    padding: 30px;
    .card {
      width: 100%;
      box-sizing: border-box;
      border-radius: 10px;
      margin-bottom: 20px;
      .card-item {
        height: 100%;
        .left {
          margin-right: 24px;
          .image {
            border: 5px solid #000000;
            border-radius: 50%;
            padding: 24px;
          }
          .point {
            position: relative;
            &:after {
              content: '';
              position: absolute;
              right: 18px;
              top: 20px;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: #E8252A;
            }
          }
        }
        .right {
          border-bottom: 1px solid #828282;
          padding: 20px 0;
          width: 100%;
          .title {
            padding: 0;
            color: #000;
            font-size: 22px;
            font-weight: bold;
          }
          .content {
            padding: 20px 0;
            color: #000;
            font-size: 17px;
            line-height: 1.2;
            p {
              width: 80%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .date {
            font-size: 17px;
            color: #828282;
          }
        }
      }
    }
  }
</style>
